import { Permissions } from '@shared/enums/permissions.enum';
export class AuthHelper {
    get permissions() { return Permissions; }
}
